import * as materials from "materials/legacy/legacy-gradient";
export { materials };
export default materials;
